import React, { useEffect, useRef, useState } from "react";
import { Modal, Input } from "antd";
import type { CSSProperties } from "react";
const { TextArea } = Input;

interface RatingFeedbackProps {
  onFeedbackSubmit: (feedback: string) => void;
  style?: CSSProperties;
  onClose: () => void;
  setIsFeedbackOpen: (open: boolean) => void;
}

export default function RatingFeedback({
  onFeedbackSubmit,
  style,
  onClose,
  setIsFeedbackOpen,
}: RatingFeedbackProps) {
  const feedbackRef = useRef<HTMLDivElement>(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedFeedbackType, setSelectedFeedbackType] = useState<
    string | null
  >(null);
  const [detailedFeedback, setDetailedFeedback] = useState("");

  const feedbackOptions = [
    "Factually incorrect",
    "Didn't follow instructions",
    "Too brief, missing details",
    "Too long or unclear",
    "Other",
  ];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const modalElement = document.querySelector(".ant-modal");
      if (
        feedbackRef.current &&
        !feedbackRef.current.contains(event.target as Node) &&
        !modalElement?.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const handleModalOk = () => {
    onFeedbackSubmit(detailedFeedback);
    setIsDetailModalOpen(false);
    setIsFeedbackOpen(false);
  };

  const handleFeedbackTypeChange = (feedbackType: string) => {
    setSelectedFeedbackType(feedbackType);
    if (feedbackType === "Other") {
      setIsDetailModalOpen(true);
    } else {
      onFeedbackSubmit(feedbackType);
      setIsFeedbackOpen(false);
      setIsDetailModalOpen(false);
    }
  };

  return (
    <>
      <div
        ref={feedbackRef}
        style={style}
        className="flex flex-col justify-between items-start gap-1 absolute left-[-4px] z-1000 bg-white rounded-sm w-[240px] shadow-omni feedback-box-with-arrow"
      >
        <div className="p-4 w-full">
          <p className="text-[#064C68] font-semibold mb-2">What went wrong?</p>
          <ul className="text-[#2B4752] space-y-1">
            {feedbackOptions.map((option) => (
              <li
                key={option}
                onClick={() => handleFeedbackTypeChange(option)}
                className={`cursor-pointer rounded-md py-1 px-2 hover:bg-gray-50 ${
                  selectedFeedbackType === option
                    ? "bg-[#d2eff980]! text-[#06709B] font-medium"
                    : "text-[#2B4752]"
                }`}
              >
                {option}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <Modal
        title="What went wrong?"
        centered
        open={isDetailModalOpen}
        onOk={handleModalOk}
        okText="Submit"
        onCancel={() => {
          setIsDetailModalOpen(false);
          setIsFeedbackOpen(false);
          setDetailedFeedback("");
          setSelectedFeedbackType(null);
        }}
        width={690}
        className="feedback-modal"
      >
        <p className="mb-4">
          Your feedback helps us improve! Ask Vivo evolves with the help of
          users like you. Share your thoughts to make it even better.
        </p>
        <TextArea
          className="feedback-box mb-5"
          placeholder="Please specify what went wrong"
          value={detailedFeedback}
          onChange={(e) => {
            setDetailedFeedback(e.target.value);
          }}
          rows={8}
        />
      </Modal>
    </>
  );
}
